import { render, staticRenderFns } from "./OfficeHourManager.vue?vue&type=template&id=bcf0587c&scoped=true"
import script from "./OfficeHourManager.vue?vue&type=script&lang=js"
export * from "./OfficeHourManager.vue?vue&type=script&lang=js"
import style0 from "./OfficeHourManager.vue?vue&type=style&index=0&id=bcf0587c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf0587c",
  null
  
)

export default component.exports